module.exports = __webpack_public_path__ + "img/cp_04.5ad0de74.png";